import type { FaireProductEntity } from "../../entity_types/product";

export const p_z3ntx2mh8q: FaireProductEntity = {
  token: "p_z3ntx2mh8q",
  type: "product",
  name: "Messenger Pigeon Birthday/Congratulations Pop-Up Card",
  brandToken: "b_apnblrf5vf",
  brandName: "UWP Luxe",
  imageUrl:
    "https://cdn.faire.com/fastly/dc0baa062046e74c01982f03ea75e09c7ab7ec2120d5365fe8b7bd7c90676215.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e1d21470c212da169c9d18d3c69ca1f2fde84b6f792776379d23b3f614fa7b3f.jpeg",
    "https://cdn.faire.com/fastly/19f6bbf3df84969172d90b2ebfca2be9282e916b141da60a86b18f1f24aa3724.jpeg",
    "https://cdn.faire.com/fastly/9ee304a91300cc2231c434c5dc39399b1e6a14974073a560c035cdfae6775c68.jpeg",
  ],
  priceDollars: 3.25,
  description:
    "Our Dear Alchemy, Collection features curious and petite greeting cards with die-cut interactive elements. Deliver birthday wishes to a coo friend.\n\n𝐅𝐫𝐨𝐧𝐭 𝐜𝐨𝐩𝐲:\nI Bring Good News\n\n𝐈𝐧𝐬𝐢𝐝𝐞 𝐜𝐨𝐩𝐲:\nPoo York Times: Everyone Gathers to Celebrate You! / Cheers\n\n• Fits inside 5″ L x 3.5″ W mailable envelope\n• Printed in full color and finished with iridescent foil.\n• Newspaper-printed envelope",
  tags: [],
  msrpDollars: 6.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:06.959Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
